import { createGlobalStyle } from "styled-components";

//images
import HawkesBackground from "../assets/images/hawkes-bg.png";

//fonts
import GearedSlabEOT from "../assets/fonts/GearedSlab-Regular.eot";
import GearedSlabEOTIE from "../assets/fonts/GearedSlab-Regular.eot?#iefix";
import GearedSlabWoff2 from "../assets/fonts/GearedSlab-Regular.woff2";
import GearedSlabWoff from "../assets/fonts/GearedSlab-Regular.woff";
import GearedSlabTtf from "../assets/fonts/GearedSlab-Regular.ttf";
import GearedSlabSvg from "../assets/fonts/GearedSlab-Regular.svg";

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #45b8a1;
    text-align: center;
    font-family: GearedSlab;
    background-image: url(${HawkesBackground});
    background-repeat: repeat;
  }
  @font-face {
    font-family: GearedSlab;
    src: url(${GearedSlabEOT});
    src: url(${GearedSlabEOTIE}) format('embedded-opentype'),
        url(${GearedSlabWoff2}) format('woff2'),
        url(${GearedSlabWoff}) format('woff'),
        url(${GearedSlabTtf}) format('truetype'),
        url(${GearedSlabSvg}) format('svg');
    font-weight: normal;
    font-style: normal;
  }
  ul {
    list-style-type: none;
    margin: unset;
    padding: unset;
  }
  h1, h2, h3, h4 {
    font-family: GearedSlab;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    text-align: center;
    margin:unset;
  }
  h1 {
    font-size: 120px;
    letter-spacing: 2.9px;
  }
  h2 {
    font-size: 100px;
    letter-spacing: 2.4px;
  }
  h3 {
    font-size: 80px;
    letter-spacing: 1.9px;
  }
  h4 {
    font-size: 42px;
    letter-spacing: 1px;
  }
  .btn {
    border-radius: 0;
  }
  .card {
    border-radius: 0;
    background-color: transparent;
    border-style: none;
    padding: unset;
  }
  .card-header {
    background-color: transparent;
    border-bottom: unset;
    padding: unset;
  }
  .card-body {
    text-align: left;
    font-size:20px
  }
  @media (max-width: 992px) {
    h1 {
      font-size: 70px;
      letter-spacing: 1.7px;
    }
    h2 {
      font-size: 60px;
      letter-spacing: 1.4px;
    }
    h3 {
      font-size: 50px;
      letter-spacing: 1.2px;
    }
    h4 {
      font-size: 32px;
      line-height: 0.94;
      letter-spacing: 0.8px;
    }
  }
`;

export default GlobalStyle;
